"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _usePropTypes = require("./usePropTypes");

var _lib = require("../lib");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var useDraggable = function useDraggable(props) {
  var newProps = (0, _react.useCallback)(function () {
    return (0, _usePropTypes.useComponentPropTypes)(useDraggable, props);
  }, [props])();
  var containerRef = (0, _react.useRef)();
  var handlerRef = (0, _react.useRef)();

  var _useState = (0, _react.useState)({}),
      _useState2 = _slicedToArray(_useState, 2),
      pos = _useState2[0],
      setPos = _useState2[1];

  var prevX;
  var prevY;
  var handleOnMouseMove = (0, _react.useCallback)(function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.event;
    (0, _lib.callEventMethods)(e, 'preventDefault');
    var clientX = e.clientX,
        clientY = e.clientY;
    var newPos = {
      x: prevX - clientX,
      y: prevY - clientY
    };
    prevX = clientX;
    prevY = clientY;
    var onMouseMove = newProps.onMouseMove;
    onMouseMove(e);
    setPos(newPos);
  }, []);
  var handleOnMouseUp = (0, _react.useCallback)(function (e) {
    var onMouseUp = newProps.onMouseUp;
    onMouseUp(e);
    document.removeEventListener('mousemove', handleOnMouseMove);
    document.removeEventListener('mouseup', handleOnMouseUp);
  }, []);
  var handleOnMouseDown = (0, _react.useCallback)(function () {
    var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.event;
    (0, _lib.callEventMethods)(e, 'preventDefault');
    var clientX = e.clientX,
        clientY = e.clientY;
    prevX = clientX;
    prevY = clientY;
    var onMouseDown = newProps.onMouseDown;
    onMouseDown(e);
    document.addEventListener('mouseup', handleOnMouseUp);
    document.addEventListener('mousemove', handleOnMouseMove);
  }, []);
  (0, _react.useEffect)(function () {
    var containerElem = containerRef.current;
    var handlerElem = handlerRef.current;

    if (handlerElem) {
      handlerElem.addEventListener('mousedown', handleOnMouseDown);
    } else if (containerElem) {
      containerElem.addEventListener('mousedown', handleOnMouseDown);
    }

    return function () {
      if (handlerElem) {
        handlerElem.removeEventListener('mousedown', handleOnMouseDown);
      } else if (containerElem) {
        containerElem.removeEventListener('mousedown', handleOnMouseDown);
      }
    };
  }, [containerRef, handlerRef]);
  var updatePos = (0, _react.useCallback)(function () {
    var disabled = newProps.disabled;

    if (!disabled) {
      var containerElem = containerRef.current;

      if (containerElem) {
        containerElem.style.left = "".concat(containerElem.offsetLeft - pos.x, "px");
        containerElem.style.top = "".concat(containerElem.offsetTop - pos.y, "px");
      }
    }
  }, [pos]);
  updatePos();
  return {
    containerRef: containerRef,
    handlerRef: handlerRef
  };
};

useDraggable.propTypes = {
  disabled: _propTypes["default"].bool,
  onMouseMove: _propTypes["default"].func,
  onMouseDown: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func
};
useDraggable.defaultProps = {
  disabled: false,
  onMouseMove: function onMouseMove() {},
  onMouseDown: function onMouseDown() {},
  onMouseUp: function onMouseUp() {}
};
var _default = useDraggable;
exports["default"] = _default;